module.exports = __webpack_public_path__ + "img/AA.591e3504.png";